import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // 1. ייבוא ה-hook
import UserService from '../components/services/user.service.js';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from '../components/ui/use-toast';

export default function UserLogin() {
    const { t } = useTranslation(); // 2. הפעלת ה-hook
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            await UserService.login(email, password);
            // 3. תרגום הודעות ה-toast
            toast({ title: t('toast.login_success_title') });
            window.location.href = '/';
        } catch (error) {
            toast({
                variant: "destructive",
                title: t('toast.login_error_title'),
                description: error.message || t('toast.generic_error_desc')
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#f8f5f2] px-4 py-12">
            <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-xl shadow-lg">
                <div>
                    {/* 4. תרגום הטקסטים ב-JSX */}
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-[#232946]">
                        {t('pages.login.title')}
                    </h2>
                </div>
                <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                    <div className="rounded-md shadow-sm -space-y-px">
                        <div>
                            <label htmlFor="email-address" className="sr-only">
                                {t('forms.email_placeholder')}
                            </label>
                            <Input
                                id="email-address"
                                name="email"
                                type="email"
                                autoComplete="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-[#232946] focus:border-[#232946] focus:z-10 sm:text-sm"
                                placeholder={t('forms.email_placeholder')}
                            />
                        </div>
                        <div>
                            <label htmlFor="password" className="sr-only">
                                {t('pages.login.password_placeholder')}
                            </label>
                            <Input
                                id="password"
                                name="password"
                                type="password"
                                autoComplete="current-password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-[#232946] focus:border-[#232946] focus:z-10 sm:text-sm"
                                placeholder={t('pages.login.password_placeholder')}
                            />
                        </div>
                    </div>

                    <div>
                        <Button
                            type="submit"
                            disabled={isLoading}
                            className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[#232946] hover:bg-[#121629] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#232946]"
                        >
                            {isLoading ? t('status.logging_in') : t('login.button_login')}
                        </Button>
                    </div>
                </form>
                <div className="text-sm text-center">
                    <span className="text-gray-500">{t('pages.login.no_account')} </span>
                    <Link to="/register" className="font-medium text-[#232946] hover:text-[#121629]">
                        {t('pages.login.register_here')}
                    </Link>
                </div>
            </div>
        </div>
    );
}